import {
  ExposedAssetsAdvisoryNode,
  ExposedAssetsCVENode,
} from "~/pages/space/vulnerabilities/components/exposed-assets/types";

export function flattenExposedAssetsFindings({
  findings,
}: {
  findings: Array<ExposedAssetsAdvisoryNode | ExposedAssetsCVENode>;
}) {
  const totalSpaceRiskDelta = findings.reduce((acc, finding) => {
    return acc + (finding.spaceRiskDelta?.delta || 0);
  }, 0);

  return (
    findings
      .filter(
        (
          finding,
        ): finding is ExposedAssetsAdvisoryNode | ExposedAssetsCVENode =>
          finding?.__typename === "CveFinding" ||
          finding?.__typename === "AdvisoryFinding",
      )
      // We only display one finding but sum up space risk delta
      .slice(0, 1)
      .map((finding) => ({
        ...finding,
        ...(finding.spaceRiskDelta
          ? {
              spaceRiskDelta: {
                ...finding.spaceRiskDelta,
                delta: totalSpaceRiskDelta,
              },
            }
          : {}),
      }))
  );
}
